import React, { useState, useEffect } from "react";
import { FormControl, MenuItem, Select, InputLabel, Popper, Paper, ClickAwayListener } from '@mui/material';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { DateRangeFilter } from "src/mtska-frontend-app-component/components/List/customSelectionFilter/dateRangeFilter/DateRangeFilter";
import { Button, InputAutocomplete } from 'src/mtska-frontend-app-component';
import JSONPretty from 'react-json-pretty';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import FiltersPanel from "src/mtska-frontend-app-component/components/List/FiltersPanel";
import { getColumnDefinition } from 'src/mtska-frontend-app-component/components/List/list.functions.jsx'
import { useDataProvider } from "src/mtska-frontend-data-provider";

const Filters = ({ dataProviderName, filters:defaultFilters, style }) => {
    const { t } = useTranslation();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const { settings, settingsLoaded, addFilter } = useSettingsContext(dataProviderName, defaultFilters);
    const [filterPanelVisible, setFilterPanelVisible] = useState(false);
    const { item: config } = useDataProvider('configs/config');

    const [customDateRange, setCustomDateRange] = useState();
    const [advertisingSourceName, setAdvertisingSourceName] = useState();
    const [areaName, setAreaName] = useState();
    const [shopName, setShopName] = useState();
    const [buyerAgentName, setBuyerAgentName] = useState();
    const [sellerAgentName, setSellerAgentName] = useState();
    const [selectedValueStatus, setSelectedValueStatus] = useState();
    const [selectedValueProduct, setSelectedValueProduct] = useState();

    useEffect(() => {
        if (settingsLoaded == false) return;

        setCustomDateRange(filterModel?.items?.find(f => f.field === 'registered_at')?.value || null);
        setAdvertisingSourceName(filterModel?.items?.find(f => f.field === '_related_source_name')?.value || null);
        setAreaName(filterModel?.items?.find(f => f.field === '_related_area_name')?.value || null);
        setShopName(filterModel?.items?.find(f => f.field === '_related_shop_name')?.value || null);
        setBuyerAgentName(filterModel?.items?.find(f => f.field === '_related_buyerAgent_fullname')?.value || null);
        setSellerAgentName(filterModel?.items?.find(f => f.field === '_related_sellerAgent_fullname')?.value || null);

        setSelectedValueStatus(filterModel?.items?.find(f => f.field === 'status')?.value || null);
        setSelectedValueProduct(filterModel?.items?.find(f => f.field === 'product')?.value || null);
    }, [filterModel])

    return (drawable &&
        <>
            {/* filterModel in Filters
            <JSONPretty data={filterModel} className="json-wrapper" style={{ overflow: 'scroll', fontSize: '10px' }}></JSONPretty> */}

            <Box className="dashboard-section-filters" sx={style}>
                <div>
                    <DateRangeFilter
                        applyValue={(updatedItem) => {
                            addFilter('registered_at', updatedItem.value, 'between')
                        }}
                        item={{
                            field: 'registered_at',
                            operator: 'between',
                            value: customDateRange,
                        }}
                        value={customDateRange}
                        mode="autocompleteInput"
                    />
                </div>

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="commercials/area/autocomplete"
                    label={t('area')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={areaName ? { "name": areaName } : null}
                    onChange={(v) => {
                        addFilter('_related_area_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="commercials/shop/autocomplete"
                    label={t('shop_name')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={shopName ? { name: shopName } : null}

                    // per attivare questo filtro è necessario che Shop abbia le viste

                    // filters={areaName && {
                    //     items: [
                    //         {
                    //             field: '_related_area_name',
                    //             operator: 'equals',
                    //             value: areaName
                    //         }
                    //     ]
                    // }}

                    onChange={(v) => {
                        addFilter('_related_shop_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />


                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="persons/employment/autocomplete"
                    label={t('Buyer agent')}
                    filters={{
                        items: [
                            {
                                field: "role",
                                operator: "equals",
                                value: "Agent"
                            },
                            {
                                field: "terminated_at_readable",
                                operator: "isEmpty",
                                value: "_"
                            },
                        ]
                    }}
                    searchkey={'_related_person_fullname'}
                    labelkey={'_related_person_fullname'}
                    project={['_related_person_fullname']}
                    value={buyerAgentName ? { _related_person_fullname: buyerAgentName } : null}
                    onChange={(v) => {
                        addFilter('_related_buyerAgent_fullname', v ? v?._related_person_fullname : null);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="persons/employment/autocomplete"
                    label={t('Seller agent')}
                    filters={{
                        items: [
                            {
                                field: "role",
                                operator: "equals",
                                value: "Agent"
                            },
                            {
                                field: "terminated_at_readable",
                                operator: "isEmpty",
                                value: "_"
                            },
                        ]
                    }}
                    searchkey={'_related_person_fullname'}
                    labelkey={'_related_person_fullname'}
                    project={['_related_person_fullname']}
                    value={sellerAgentName ? { _related_person_fullname: sellerAgentName } : null}
                    onChange={(v) => {
                        addFilter('_related_sellerAgent_fullname', v ? v?._related_person_fullname : null);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="advertisings/source/autocomplete"
                    label={t('source')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={advertisingSourceName ? { name: advertisingSourceName } : null}
                    onChange={(v) => {
                        addFilter('_related_source_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <FormControl style={{ flex: '1' }} size="small">
                    <InputLabel
                        id="status-label"
                        sx={{
                            backgroundColor: 'white',
                            px: 0.5,
                        }}
                        shrink={selectedValueStatus ? true : false}
                    >
                        {t("status")}
                    </InputLabel>
                    <Select
                        name="status"
                        value={selectedValueStatus}
                        labelId="status-label"
                        onChange={(e) => {
                            setSelectedValueStatus(e.target.value);
                            addFilter('status', e.target.value, 'equals');
                        }}
                    >
                        <MenuItem value="">{t("no choice")}</MenuItem>
                        <MenuItem value="new">{t("new")}</MenuItem>
                        <MenuItem value="existing">{t("existing")}</MenuItem>
                    </Select>
                </FormControl>

                <FormControl style={{ flex: '1' }} size="small">
                    <InputLabel
                        id="product-label"
                        sx={{
                            backgroundColor: 'white',
                            px: 0.5,
                        }}
                        shrink={selectedValueProduct ? true : false}
                    >
                        {t("product")}
                    </InputLabel>
                    <Select
                        name="product"
                        value={selectedValueProduct}
                        labelId="product-label"
                        onChange={(e) => {
                            setSelectedValueProduct(e.target.value);
                            addFilter('product', e.target.value, 'equals');
                        }}
                    >
                        <MenuItem value="">{t("select")}</MenuItem>
                        <MenuItem value="buy">{t("buy")}</MenuItem>
                        <MenuItem value="rent">{t("rent")}</MenuItem>
                        {/* <MenuItem value="sell">{t("sell")}</MenuItem> */}
                        {/* <MenuItem value="rent_in">{t("rent_in")}</MenuItem> */}
                        {/* <MenuItem value="lease_out">{t("lease_out")}</MenuItem> */}
                        
                        <MenuItem value="referral_out">{t("referral_out")}</MenuItem>
                        <MenuItem value="penalty_fee">{t("penalty_fee")}</MenuItem>
                    </Select>
                </FormControl>

                <Button onClick={() => setFilterPanelVisible(!filterPanelVisible)} icon="faEllipsisVertical"></Button>
            </Box>

            <ClickAwayListener onClickAway={() => setFilterPanelVisible(false)}>
                <Popper open={filterPanelVisible}>
                    <Paper>
                        <FiltersPanel dataProviderName={dataProviderName} columns={getColumnDefinition(settings, config, dataProviderName, t)} />
                    </Paper>
                </Popper>
            </ClickAwayListener>
        </>
    )
}

export default Filters;